import { TabType } from '../store/schema/TabViewState';
var tabHandlers = {};
export function registerTabHandler(type, handler) {
    tabHandlers[TabType[type]] = handler;
}
export function getTabHandler(type) {
    return tabHandlers[TabType[type]];
}
//# sourceMappingURL=TabHandler.js.map